// Optional diagnostic context attached to an HttpError. Lives in an options
// bag so we can extend it (e.g. with response headers) without changing the
// HttpError constructor signature in every call site.
export interface HttpErrorOptions {
  /** The request URL that produced this error. */
  url?: string
  /** The HTTP method (GET/POST/...) that produced this error. */
  method?: string
}

class HttpError extends Error {
  public readonly url?: string
  public readonly method?: string

  constructor(
    public readonly message,
    public readonly status,
    public readonly body: any = null,
    options: HttpErrorOptions = {}
  ) {
    super(message)
    this.url = options.url
    this.method = options.method
    // Hardcoded instead of `this.constructor.name` because the constructor name
    // gets minified in production builds and so it's not predictable. We want
    // it to be predictable because we identify these errors in Sentry and use
    // fingerprinting to separate them into distinct issues so that all
    // HttpError instances don't get lumped together.
    this.name = 'HttpError'
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = new Error(message).stack
    }
  }
}

export default HttpError
